import React from "react";
import { Navigate } from "react-router-dom";
import { ADMIN_TOKEN_KEY } from "../connection/adminApi";
import { isTokenLive } from "../helpers/global";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);

  // An expired operator token used to render the console until the first API
  // call came back 401, showing a signed-out operator a half-loaded page.
  if (!isTokenLive(token)) {
    if (token) {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
    }

    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminRoute;
